<script>

    import { userStore } from '../stores.js'

    import DateMethod from '../$methods/date.method.js'
    import TranslateMethods from '../$methods/translate.methods.js'

    import ButtonModal from '../$components/button.modal.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'

</script>

{#if $userStore}

    <DetailsCard
        title="Información del usuario"
        meta={`Registro: ${DateMethod.dateTimeLarge($userStore.created)}`}
        statusValue={TranslateMethods.get($userStore.status)}
    >
        <DetailsFields>
            <DetailsField label="Nombre" value={$userStore.name || 'Sin información'} />
            <DetailsField label="Corporación" value={$userStore.corporate || 'Sin información'} />
            <DetailsField label="Correo" value={$userStore.email || 'Sin información'} mono />
            <DetailsField label="Teléfono" value={$userStore.phone || 'Sin información'} />
            <DetailsField label="Rol" value={$userStore.role || 'Sin información'} />
            {#if $userStore.owner}
                <DetailsField label="Asesor principal" value={$userStore.owner.email} mono />
            {/if}
            {#if $userStore.adviser}
                <DetailsField label="Asesor" value={$userStore.adviser.email} mono />
            {/if}
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <ButtonModal modalId="user_update_location_modal" text="Actualizar dirección" icon="map-marker-alt" />
                    <ButtonModal modalId="user_update_modal" text="Actualizar información" icon="edit" />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}